{
	"title": "Atributos de carbono capturado",
	"buttonTitle": "Captura y almacenamiento de carbono",
	"table": {
		"materialDescription": "Material",
		"quantity": "Cantidad",
		"productGwpTotal": "Producto PCA Total",
		"bundledCarbonReductions": "Reducciones de carbono combinadas",
		"remainingGwp": "PCA restante",
		"epdForPhysicalMaterial": "EPD para material físico",
		"carbonPlantName": "Brevik, Noruega"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "es el legítimo poseedor de las reducciones de carbono reportadas."
	},
	"modal": {
		"title": "Captura y almacenamiento de carbono",
		"description": "La Captura y Almacenamiento de Carbono (CCS) es una tecnología que puede capturar las emisiones de dióxido de carbono (CO2) producidas por el proceso de calcinación y el uso de combustibles en la operación del horno, evitando que el dióxido de carbono ingrese a la atmósfera y almacenándolo permanentemente bajo tierra. El CO2 capturado en la planta de Heidelberg Materials en Brevik, Noruega, se comprime y se transporta a un lugar de almacenamiento bajo el Mar del Norte. Las instalaciones de nuestra planta de Brevik capturarán 400.000 toneladas de CO2 al año.",
		"showLink": "Obtenga más información sobre el proceso de captura de carbono",
		"buttonClose": "Cerrar"
	},
	"footnote": "1) Las reducciones de carbono compensan las etapas A1-A3 del inventario del ciclo de vida del cemento."
}
